export default __webpack_public_path__ + "static/media/06_Business-Portrait-EschweilerPhotography_21A0047 Kopie.a0aa52eb.jpg";